var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1444.562,
    height: 1171.837,
    viewBox: "0 0 1444.562 1171.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail_Success",
    "data-name": "Mail Success",
    transform: "translate(-1149.895 -3301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(-3604.154 -0.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-2077.952 3178.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(6769.949 45.96)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "a607546c832ea069bbec792023522cad",
    transform: "translate(7156.095 392.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M368.6,113.609V2.5H35.277C18.611,2.5,7.5,13.611,7.5,30.277V399.714l202.773,158.33c19.444,16.666,47.221,16.666,69.443,0L482.49,399.714V113.609Z",
    transform: "translate(89.72 12.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M87.832,12.2,26.722,59.421C12.833,70.532,4.5,87.2,4.5,103.865V437.191a55.718,55.718,0,0,0,55.554,55.554H587.821a55.718,55.718,0,0,0,55.554-55.554V103.865c0-16.666-8.333-33.333-22.222-44.444L560.044,12.2",
    transform: "translate(9.389 272.278)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M615.8,59.421,554.688,12.2H82.476L21.366,59.421C13.033,64.977,7.478,73.31,4.7,78.865l280.55,219.44c19.444,16.666,47.221,16.666,69.443,0L635.242,78.865c-5.555-5.555-11.111-13.889-19.444-19.444Z",
    transform: "translate(14.744 272.278)",
    fill: "#dbcbad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M479.712,113.609,368.6,2.5H35.277C18.611,2.5,7.5,13.611,7.5,30.277V399.714l202.773,158.33c19.444,16.666,47.221,16.666,69.443,0L482.49,399.714V113.609Z",
    transform: "translate(89.72 12.539)",
    fill: "#eeebe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M52.021,101.787V29.566c0-5.555,0-11.111,2.778-16.666L18.689,43.455C13.133,49.01,7.578,54.566,4.8,62.9Z",
    transform: "translate(17.422 291.022)",
    fill: "#9d917a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M131.609,113.609H20.5V2.5Z",
    transform: "translate(437.824 12.539)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M370.936,479.758H287.6c-8.333,0-13.889-5.556-13.889-13.889s5.556-13.889,13.889-13.889h83.332c8.333,0,13.889,5.555,13.889,13.889S379.269,479.758,370.936,479.758Z",
    transform: "translate(226.273 215.823)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M332.212,275.447c-13.889,0-30.555-5.555-41.666-13.889L10,39.341C4.441,33.786,1.664,25.452,7.219,19.9s13.889-8.333,19.444-2.778l280.55,219.44c13.889,11.111,36.11,11.111,50,0L637.761,17.119c5.555-5.555,13.889-2.778,19.444,2.778s2.778,13.889-2.778,19.444l-280.55,219.44C362.767,269.892,346.1,275.447,332.212,275.447Z",
    transform: "translate(1.114 322.913)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M493.1,426.991c-8.333,0-13.889-5.555-13.889-13.889V127c0-8.333,5.555-13.889,13.889-13.889s13.889,5.555,13.889,13.889V413.1C506.989,421.436,501.434,426.991,493.1,426.991Zm-472.212,0C12.555,426.991,7,421.436,7,413.1V43.666C7,21.444,26.444,2,48.666,2H381.992c8.333,0,13.889,5.555,13.889,13.889s-5.555,13.889-13.889,13.889H48.666c-8.333,0-13.889,5.555-13.889,13.889V413.1C34.777,421.436,29.222,426.991,20.889,426.991Z",
    transform: "translate(76.332 -0.849)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M601.209,780.871H73.443C34.555,780.871,4,750.316,4,711.428V378.1c0-22.222,8.333-41.666,27.777-55.554l61.11-47.221c5.555-5.555,13.889-2.778,19.444,2.778s2.778,13.889-2.778,19.444l-61.11,47.221q-16.666,12.5-16.666,33.333V711.428c0,22.222,19.444,41.666,41.666,41.666H601.209c22.222,0,41.666-19.444,41.666-41.666V378.1q0-20.833-16.666-33.333L565.1,297.548c-5.555-5.555-8.333-13.889-2.778-19.444s13.889-8.333,19.444-2.778l61.11,47.221c16.666,13.889,27.777,33.333,27.777,55.554V711.428C670.652,750.316,640.1,780.871,601.209,780.871ZM573.432,142H462.323c-8.333,0-13.889-5.555-13.889-13.889V17a15.276,15.276,0,0,1,8.333-13.889c5.555-2.778,11.111,0,13.889,2.778L581.765,117c5.555,5.555,5.555,11.111,5.555,16.666A15.275,15.275,0,0,1,573.432,142Zm-97.22-27.777H540.1L476.212,50.33Z",
    transform: "translate(-4 -1.959)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M19637.246,15265.7s-74.941,123.609,0,216.318,0,79.959,0,79.959l116.27-61.807s249.539,56.4,303.621-18.152,20.473-203.572,0-216.318S19637.246,15265.7,19637.246,15265.7Z",
    transform: "translate(-11839.695 -15081.132)",
    fill: "#c2b59c",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M2692.289-1883.548c-1.856,22.145-6.044,48.179-24.205,63.208-21.372,17.686-55.74,13.566-81.531,13.783-30.873.257-61.731.786-92.59,1.355-32.458-.285-64.957.84-97.429,1.613-5.421.068-10.842.176-16.263.23-15.68.163-31.415.556-47.135.719-.109.989-.2,1.979-.312,2.968-29.4,17.293-60.037,32.553-90.584,47.867,10.991-19.936,22.145-40.495,27.972-61.487a3.723,3.723,0,0,0-6.451-3.524c-2.073,2.277-4.066,4.675-6.031,7.128-13.783-5.448-25.519-14.284-33.244-28.487-11.14-20.491-12.414-45.292-12.6-68.1-.176-22.416.258-45.306,4.6-67.369,4.946-25.086,16.574-49.033,39.884-61.636,22.05-11.926,48.653-12.645,73.115-12.1,59.062,1.287,118.123,4.717,177.144,7.183,29.449,1.233,58.939,2.209,88.375,3.727,25.356,1.315,52.678,4.066,71.611,22.9C2698.577-1981.762,2695.745-1924.923,2692.289-1883.548Zm19.3-32.892c-.475-24.774-2.413-50.144-10.707-73.684-7.562-21.454-21.643-39.763-41.864-50.551-25.167-13.4-54.887-13.376-82.656-14.677-73.047-3.456-146.108-6.736-219.142-10.422-50.333-2.534-111.509-6.044-143.276,41.579-27.362,41.023-27.186,102.51-22.538,149.863,1.437,14.69,4.622,29.449,10.584,42.785-3.523,2.439-5.394,7.332-1.951,11.736a82.625,82.625,0,0,0,33.678,25.235,84.518,84.518,0,0,0,9.839,5.1c-11,17.537-20.532,36.6-30.655,53.613-4.4,7.427,2.331,18.052,11.275,13.81,39.479-18.784,78.618-38.842,119.139-55.172a11.37,11.37,0,0,0,4.675-3.334c24.571-1.125,49.168-2.629,73.726-3.564,5.19-.19,10.38-.393,15.571-.583,43.477.189,86.939.474,130.442.23,29.761-.176,63.669,3.754,92.116-6.925,22.687-8.5,37.961-27.809,44.832-50.591C2711.926-1866.025,2712.062-1891.557,2711.587-1916.44Z",
    transform: "translate(5553.964 2218.424)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M2275.289-1933.873c-3.632-.014-7.264.135-10.9.339,2.534-2.684,5.014-5.408,7.359-8.24,3.659-4.4-3.225-11.167-7.386-7.061-3.008,2.968-5.854,6.1-8.66,9.27-.326-5.15-.976-10.286-2.927-14.989-.881-2.128-4.4-2.141-5.123.149-1.531,4.852-1.667,9.947-1.559,15.057a45.5,45.5,0,0,0-12.265-8.2c-2.127-.881-4.634,1.6-3.523,3.727,2.344,4.527,5.855,8.226,9.541,11.75a45.6,45.6,0,0,0-14.461,2.886c-2.127.881-2.155,4.4.135,5.123,4.865,1.531,9.961,1.68,15.057,1.559a45.661,45.661,0,0,0-8.186,12.265c-.881,2.141,1.586,4.635,3.727,3.523a42.555,42.555,0,0,0,10.531-8.281c.122,3.537.271,7.061.6,10.584.542,5.692,10.191,5.611,10.219-.244.027-3.632-.122-7.251-.325-10.883,2.683,2.521,5.407,5.014,8.226,7.359,4.4,3.646,11.167-3.239,7.061-7.386-2.561-2.588-5.231-5.055-7.955-7.481,3.7-.109,7.386-.271,11.045-.61C2281.225-1924.184,2281.144-1933.833,2275.289-1933.873Z",
    transform: "translate(5554.538 2220.26)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M2350.174-1933.873c-3.632-.014-7.264.135-10.882.339,2.521-2.684,5-5.408,7.345-8.24,3.659-4.4-3.226-11.167-7.386-7.061-3.009,2.968-5.855,6.1-8.66,9.27-.325-5.15-.963-10.286-2.914-14.989-.895-2.128-4.4-2.141-5.136.149-1.532,4.852-1.667,9.947-1.545,15.057a45.783,45.783,0,0,0-12.278-8.2c-2.127-.881-4.635,1.6-3.523,3.727,2.358,4.527,5.854,8.226,9.554,11.75a45.6,45.6,0,0,0-14.474,2.886c-2.128.881-2.155,4.4.135,5.123,4.865,1.531,9.961,1.68,15.07,1.559a45.738,45.738,0,0,0-8.2,12.265c-.88,2.141,1.6,4.635,3.727,3.523a42.862,42.862,0,0,0,10.543-8.281c.108,3.537.258,7.061.6,10.584.529,5.692,10.178,5.611,10.2-.244.027-3.632-.122-7.251-.325-10.883,2.684,2.521,5.408,5.014,8.226,7.359,4.418,3.646,11.182-3.239,7.061-7.386-2.547-2.588-5.231-5.055-7.941-7.481,3.686-.109,7.373-.271,11.032-.61C2356.11-1924.184,2356.028-1933.833,2350.174-1933.873Z",
    transform: "translate(5555.774 2220.26)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M2429.9-1933.873c-3.632-.014-7.264.135-10.9.339,2.534-2.684,5.014-5.408,7.359-8.24,3.659-4.4-3.226-11.167-7.386-7.061-3.009,2.968-5.854,6.1-8.66,9.27-.325-5.15-.962-10.286-2.914-14.989-.9-2.128-4.405-2.141-5.137.149-1.531,4.852-1.666,9.947-1.558,15.057a45.5,45.5,0,0,0-12.265-8.2c-2.128-.881-4.635,1.6-3.524,3.727,2.345,4.527,5.855,8.226,9.554,11.75a45.607,45.607,0,0,0-14.474,2.886c-2.128.881-2.155,4.4.135,5.123,4.865,1.531,9.961,1.68,15.07,1.559a45.716,45.716,0,0,0-8.2,12.265c-.881,2.141,1.6,4.635,3.727,3.523a42.872,42.872,0,0,0,10.544-8.281c.108,3.537.257,7.061.6,10.584.529,5.692,10.178,5.611,10.205-.244.027-3.632-.122-7.251-.325-10.883,2.683,2.521,5.407,5.014,8.226,7.359,4.418,3.646,11.18-3.239,7.061-7.386-2.548-2.588-5.231-5.055-7.942-7.481,3.686-.109,7.373-.271,11.032-.61C2435.834-1924.184,2435.753-1933.833,2429.9-1933.873Z",
    transform: "translate(5557.091 2220.26)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M2504.783-1933.873c-3.632-.014-7.25.135-10.883.339,2.521-2.684,5.015-5.408,7.359-8.24,3.646-4.4-3.239-11.167-7.386-7.061-3.009,2.968-5.868,6.1-8.674,9.27-.325-5.15-.962-10.286-2.913-14.989-.881-2.128-4.4-2.141-5.123.149-1.531,4.852-1.68,9.947-1.559,15.057a45.789,45.789,0,0,0-12.279-8.2c-2.128-.881-4.635,1.6-3.523,3.727,2.358,4.527,5.854,8.226,9.554,11.75a45.682,45.682,0,0,0-14.474,2.886c-2.127.881-2.141,4.4.136,5.123,4.865,1.531,9.961,1.68,15.07,1.559a45.725,45.725,0,0,0-8.2,12.265c-.881,2.141,1.6,4.635,3.727,3.523a42.871,42.871,0,0,0,10.544-8.281c.108,3.537.271,7.061.6,10.584.528,5.692,10.177,5.611,10.218-.244.014-3.632-.135-7.251-.339-10.883,2.683,2.521,5.407,5.014,8.24,7.359,4.4,3.646,11.167-3.239,7.061-7.386-2.562-2.588-5.245-5.055-7.956-7.481,3.687-.109,7.373-.271,11.032-.61C2510.719-1924.184,2510.638-1933.833,2504.783-1933.873Z",
    transform: "translate(5558.331 2220.26)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M2590.067-1930.647c-3.632-.027-7.264.122-10.9.325,2.534-2.683,5.015-5.407,7.359-8.24,3.659-4.4-3.225-11.167-7.386-7.047-3.009,2.968-5.854,6.1-8.66,9.27-.326-5.164-.976-10.287-2.927-14.989-.881-2.141-4.4-2.155-5.123.136-1.531,4.865-1.667,9.961-1.559,15.057a45.659,45.659,0,0,0-12.265-8.186c-2.128-.881-4.635,1.585-3.523,3.713,2.344,4.526,5.854,8.24,9.541,11.764a45.583,45.583,0,0,0-14.46,2.873c-2.141.894-2.155,4.4.136,5.123,4.852,1.545,9.961,1.68,15.057,1.558a45.726,45.726,0,0,0-8.186,12.279c-.881,2.128,1.586,4.635,3.713,3.524a42.672,42.672,0,0,0,10.544-8.294c.109,3.537.271,7.074.6,10.585.528,5.706,10.178,5.624,10.218-.23.027-3.632-.136-7.264-.339-10.9,2.684,2.534,5.407,5.014,8.24,7.359,4.4,3.659,11.167-3.226,7.061-7.386-2.562-2.589-5.231-5.055-7.955-7.481,3.7-.109,7.386-.258,11.045-.61C2596-1920.971,2595.908-1930.62,2590.067-1930.647Z",
    transform: "translate(5559.745 2220.311)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M2654.028-1945.609c-3.008,2.968-5.854,6.1-8.659,9.27-.326-5.164-.963-10.287-2.914-14.989-.895-2.141-4.4-2.155-5.136.136-1.532,4.865-1.667,9.961-1.559,15.057a45.448,45.448,0,0,0-12.265-8.186c-2.127-.881-4.635,1.585-3.523,3.713,2.344,4.526,5.854,8.24,9.555,11.764a45.585,45.585,0,0,0-14.474,2.873c-2.128.894-2.155,4.4.135,5.123,4.866,1.545,9.961,1.68,15.07,1.558a45.467,45.467,0,0,0-8.2,12.279c-.881,2.128,1.6,4.635,3.727,3.524a42.932,42.932,0,0,0,10.543-8.294c.109,3.537.258,7.074.6,10.585.528,5.706,10.178,5.624,10.205-.23.027-3.632-.122-7.264-.325-10.9,2.683,2.534,5.407,5.014,8.226,7.359,4.418,3.659,11.181-3.226,7.061-7.386-2.548-2.589-5.231-5.055-7.955-7.481,3.7-.109,7.386-.258,11.045-.61,5.706-.529,5.625-10.178-.23-10.2-3.632-.027-7.265.122-10.883.325,2.521-2.683,5-5.407,7.345-8.24C2665.074-1942.966,2658.189-1949.729,2654.028-1945.609Z",
    transform: "translate(5560.985 2220.311)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(7326.134 642.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M1837.385-1488.278c52.282,5.343,105.857,3.734,158.379,4.788,49.9,1.016,101.9,8.522,151.594,4.307,8.67-.739,7.8-13.736-.333-14.863-51.524-7.136-106.43-2.108-158.471-3.808-50.229-1.627-101.235-5.657-151.446-3.217C1829.732-1500.7,1830.3-1489,1837.385-1488.278Z",
    transform: "translate(-1831.734 1501.838)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(0.001 13.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M2133.461-1431.137c-49.823-.019-99.608-1.886-149.394-3.217-23.46-.629-46.9-.943-70.343-1.183-22.3-.24-48.084-3.587-69.955,2.015.925-18.469,1.479-38.435-2.218-55.554-.85-3.993-6.083-3.66-6.914.148-4.567,21.149-2.588,46.55-1.516,68.143.277,5.694,9.724,5.435,10.02-.222.093-1.959.2-3.974.3-5.971,20.41,5.99,43.315,3.956,64.409,4.51,24.9.666,49.785,1.276,74.706,1.534,49.841.5,99.7.462,149.505,2.292C2140.172-1418.345,2141.429-1431.12,2133.461-1431.137Z",
    transform: "translate(-1831.76 1491.931)",
    fill: "#231f1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M2073.07-1473.47c.2-11.5-17.878-13.237-17.674-1.978.314,17.064-1.96,36.457,3.752,52.744,1.59,4.566,8.763,4.049,10.279-.277C2074.918-1438.566,2072.755-1457.108,2073.07-1473.47Z",
    transform: "translate(-1745.355 1509.099)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M1866.217-1462.844c7.339,0,8.689-11.443,1.294-11.443C1860.172-1474.288,1858.821-1462.844,1866.217-1462.844Z",
    transform: "translate(-1820.336 1512.49)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M1902.309-1457.524c12.664,0,14.993-19.763,2.219-19.763C1891.845-1477.287,1889.516-1457.524,1902.309-1457.524Z",
    transform: "translate(-1807.774 1511.331)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M1947.679-1455.084c15.123,0,17.9-23.59,2.644-23.59C1935.219-1478.674,1932.427-1455.084,1947.679-1455.084Z",
    transform: "translate(-1790.863 1510.794)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M1992.058-1457.408c9.577,0,11.333-14.92,1.682-14.92C1984.182-1472.328,1982.426-1457.408,1992.058-1457.408Z",
    transform: "translate(-1772.255 1513.249)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M2035.479-1477.1a27.916,27.916,0,0,1-3.9-.554c-3.069-.61-6.544.592-9.077,2.163a13.658,13.658,0,0,0-4.955,5.251,14.083,14.083,0,0,0,2.7,17.119,14.33,14.33,0,0,0,15.659,2.7c5.546-2.514,9.428-9.132,8.208-15.252a24.886,24.886,0,0,1-.536-3.679C2043.391-1473.163,2039.213-1476.879,2035.479-1477.1Z",
    transform: "translate(-1760.601 1511.122)",
    fill: "#231f1f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(5332.437 3628.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    transform: "translate(8.565 9.804)",
    fill: "#3a7735",
    stroke: "#acd6ac",
    strokeWidth: 1,
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.385,
    cy: 67.384,
    rx: 67.385,
    ry: 67.384,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.385,
    cy: 67.384,
    rx: 66.885,
    ry: 66.884,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M1011.293-1396.726c14.046-1.821,27.192-3.68,41.206,1.17,14.059,4.876,26.987,15.108,34.418,28.149,6.142,16.3,3.888,6.2,6.038,17.708,3.579,26.68-14.375,55.349-40.28,63.658-34.193,10.96-72.964-15.511-77.176-50.708C972.281-1363.65,988.995-1385.3,1011.293-1396.726Zm-10,121.529c59.185,35.521,124.771-29.4,109.67-87.854,2.061-11.35-9.117-20.725-10.205-22.311-19.174-27.993-70.481-47.549-99.022-22.715a6.643,6.643,0,0,0-2.284,4.083,78.885,78.885,0,0,0-34.272,40.748C952.789-1328.7,971.177-1293.27,1001.292-1275.2Z",
    transform: "translate(-961.266 1419.46)",
    fill: "#231f1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1959.082-1594.158c22.389-28.578,43.855-57.793,65.335-87.048,7.021-9.57-7.762-20.3-14.887-10.818-19.321,25.731-38.6,51.448-57.3,77.622-9.634-14.809-19.711-31.556-35.028-38.759-1.638-.767-3.094.871-2.978,2.406,1.548,20.8,20.05,39.981,31.127,57C1948.55-1588.853,1955.974-1590.179,1959.082-1594.158Z",
    transform: "translate(3462.069 5332.211)",
    fill: "#231f1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(33 1383.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M1075.868-1899.991c1.316-11.784,6.826-31.2-2.256-40.909-3-3.208-7.067-2.787-9.916.29-8.864,9.568-3.283,29.349-1.991,40.936C1062.609-1891.573,1074.984-1892.079,1075.868-1899.991Z",
    transform: "translate(693.688 3972.895)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M886.022-1880.759c2.112,2.291,4.084,4.716,6.111,7.074,6.518,7.583,18.371.054,14.694-9.137-1.16-2.894-2.4-5.775-3.46-8.709-1.289-3.591-2.02-7.1-4.854-9.915-4.05-4.006-9.569-5.547-14.694-2.358-5.164,3.2-6.092,8.722-4.387,14.215C880.6-1885.837,883.466-1883.52,886.022-1880.759Z",
    transform: "translate(718.709 3959.939)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M992.171-1842.764c3.105,10.455,20.034,8.263,17.181-2.714-10.575-40.726-18.035-81.92-26.424-123.133-4.662-22.894-39.026-13.413-30.948,9.29C965.785-1920.527,980.443-1882.254,992.171-1842.764Z",
    transform: "translate(685.164 3899.764)",
    fill: "#231f1f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSuccess);
export default __webpack_public_path__ + "static/media/MailSuccess.a8ffd597f64d4afdc30c5f45060d706c.svg";
export { ForwardRef as ReactComponent };